// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__ufTfl","adWrapper":"styles_adWrapper__LL42q","ad":"styles_ad__5tOKl","loadMore":"styles_loadMore__Bc_L_","boxLoader":"styles_boxLoader__7Vaj_"};